<script setup lang="ts">
import type { JournalArticle } from '~/utils/solr/journal'
import type { LawAndCommentary } from '~/utils/solr/law-and-commentary'
import type { BookAndArticle } from '~/utils/solr/literature'

type Content = BookAndArticle | LawAndCommentary | JournalArticle
const props = defineProps<{
  content: Content | null
  loading?: boolean
  isScrollTop?: boolean
}>()

const headerOpen = ref(false)

const scrollTop = toRef(props, 'isScrollTop')

const metadataOrientation = computed<'horizontal' | 'vertical'>(() => {
  const nodeType = props.content?.nodeType
  if (nodeType === 'journal_article' || nodeType === 'journal_editorial') {
    return 'vertical'
  }
  return 'horizontal'
})

watch(scrollTop, (newVal) => {
  if (newVal) {
    headerOpen.value = false
  }
})
</script>

<template>
  <section v-if="scrollTop" class="flex flex-col gap-xs mb-l bg-surface-elevated">
    <h1 class="title-m font-bold grow dark:text-white">
      {{ content?.title }}
    </h1>
    <h2 v-if="content && 'subtitle' in content" class="font-body title-xs !font-normal dark:text-white">
      {{ content.subtitle }}
    </h2>
    <ReadingMetadata v-if="content" :node="content" :orientation="metadataOrientation" />
  </section>
  <details
    v-else
    :open="headerOpen"
    class="flex flex-col justify-between bg-surface-elevated pb-2xs border-b-4 border-surface-primary w-full"
    @toggle="headerOpen = !headerOpen"
  >
    <summary class="flex gap-2xs items-center">
      <DetailsIcon :open="headerOpen" />
      <h1 class="title-xs font-bold dark:text-white">
        {{ content?.title }}
      </h1>
    </summary>
    <div>
      <h2 v-if="content && 'subtitle' in content" class="font-body title-xs !font-normal pt-2xs dark:text-white">
        {{ content.subtitle }}
      </h2>
      <ReadingMetadata v-if="content" class="pt-xs" :node="content" :orientation="metadataOrientation" />
    </div>
  </details>
</template>
